import { AxiosResponse } from 'axios';
import qs from 'qs';
import {
  AuthorDetailsResponseType,
  BlogPostResponseType,
  QueryType,
} from 'src/types';

import { API } from './index';
import { createPostsfromRawPosts } from '@utils/common.utils';

async function fetchBlogsByAuthor(query: QueryType) {
  const { start, limit, authorSlug } = query;

  const queryData = decodeURIComponent(
    qs.stringify(
      {
        _start: start,
        _limit: limit,
        'author.Slug': authorSlug,
        _sort: 'published_at:DESC',
      },
      { encode: false },
    ),
  );

  const url = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/blogs/fetchmany?${queryData}`;

  const countQueryData = decodeURIComponent(
    qs.stringify(
      {
        _start: start,
        'author.Slug': authorSlug,
        _sort: 'published_at:DESC',
      },
      { encode: false },
    ),
  );

  const countUrl = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/blogs/count/?${countQueryData}`;

  const authorPromise = API.get<BlogPostResponseType[]>(url);
  const authorCountPromise = API.get<number>(countUrl);

  const [{ data }, { data: totalBlogCount }] = await Promise.all([
    authorPromise,
    authorCountPromise,
  ]);

  const list = data.map(post => createPostsfromRawPosts(post));
  return { list, totalBlogCount };
}

async function fetchAuthorDetails(slug: string) {
  const url = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/users/?Slug=${slug}`;

  const { data }: AxiosResponse<AuthorDetailsResponseType[]> = await API.get(
    url,
  );

  const {
    id,
    Name: name,
    email,
    Avatar: avatar,
    AuthorDescription: authorDescription,
    AuthorSocialLinks: authorSocialLinks,
  } = data[0];
  return { id, name, email, avatar, authorDescription, authorSocialLinks };
}

export { fetchAuthorDetails, fetchBlogsByAuthor };
